import React, { useState } from 'react';
import { Button, Col, List, Row, Space } from 'antd';
import "./../../startproj/Review";

import { Collapse, Tabs } from 'antd';

import { isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';


const { Panel } = Collapse;
const { TabPane } = Tabs;
function FMPTrackerTabContainer({
  project,
  handleProjectDetailUpdate
}) {


  const { fmpProjectDetails } = project;


  return (
    <div className="contianer-fluid col-lg-12">
      <div style={{ width: "100%", margin: "auto" }} />
      <div className="spcard revcard">
        <div className="card-text">
          <div className="row">
            <div className="col-xs-6">
              <b>Project Information</b><br />
              <b>&nbsp;&nbsp;&nbsp;Station Name:</b> {project?.id?.stationName || ''}<br />
              <b>&nbsp;&nbsp;&nbsp;Project Description:</b> {project?.projectDescription || ''}<br />
            </div>
            <div className="col-xs-2">
              <b>WO:</b> {project?.id?.workOrder || ''}<br />
              <b>BPID:</b> {project?.id?.bpid || ''}<br />
              <b>MPID:</b> {project?.mpid || ''}<br /><br />
            </div>
            <div className="col-xs-2">
              <b>WO-ISD:</b> {project?.inServiceDate} <br />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-xs-6">
              <b>Station Information</b><br />
              <b>&nbsp;&nbsp;&nbsp;State:</b> {project?.stationState || ''} <br />
              <b>&nbsp;&nbsp;&nbsp;Station Region:</b> {project?.stationRegion || ''} <br />
              <b>&nbsp;&nbsp;&nbsp;TFS Station Area: </b> {project?.tfStationArea || ''} <br />
              <b>&nbsp;&nbsp;&nbsp;TFS P&C Area: </b> {project?.pcArea || ''} <br />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-xs-6">
              <b>Reviewer Information</b><br />
              <b>&nbsp;&nbsp;&nbsp;CCA: </b> {project?.ccaNames || ''} <br />
              <b>&nbsp;&nbsp;&nbsp;RCA: </b> {project?.rcaNames || ''} <br />
              <b>&nbsp;&nbsp;&nbsp;LCA: </b> {project?.lcaNames || ''} <br />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-xs-6">
              <b>Status Details</b><br />
              <b>FMP Inquiry Status:</b> {project?.status}<br />
              <b>FMP Physical Tracks: </b> {project?.noOfPhysicalTracks} <br />
              <b>FMP P&C Tracks: </b>{project?.noOfPCETracks}  <br />
              <b>FMP Oneline Tracks: </b> {project?.noOfOnelineTracks}
            </div>
            <div className="col-xs-6">
              <br />
              <b>Total No. of SE Assets:</b> {project?.noOfSEAssets || ''}<br />
              <b>Total No. of PCE Assets:</b> {project?.noOfPCEAssets || ''}<br />
              <b>Total No. of Assets:</b> {project?.noOfAssets || ''}<br />
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}

export default FMPTrackerTabContainer;